<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width="568" persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-title.pa-4
      v-spacer
      .text-xl.font-bold.ml-10 Update claim status
      v-spacer
      v-btn(icon @click="closeDialog" small color="primary")
        v-icon mdi-close
    v-divider
    v-card-text.py-4.px-6
      template(v-if="bills.length")
        div(v-for="(bill, idx) in bills" :key="`bl-${idx}-${bill.rid}`")
          .text-sm.font-semibold.neutral700--text Billing Details
          v-row.mt-1(dense)
            v-col
              .text-xs.neutral700--text Name : {{ bill.lead.name }}
                v-btn.ml-1(icon x-small @click="copyText(bill.lead.name)")
                  v-icon(small color="neutral500") $yzi-copy-03
              .text-xs.neutral700--text Patient ID : {{ bill.lead.ic }}
                v-btn.ml-1(icon x-small @click="copyText(bill.lead.ic)")
                  v-icon(small color="neutral500") $yzi-copy-03
            v-col
              .text-xs.neutral700--text Visit Date : {{ bill.record_date | convertServerDate2 }}
                v-btn.ml-1(icon x-small @click="copyText($options.filters.convertServerDate2(bill.record_date))")
                  v-icon(small color="neutral500") $yzi-copy-03
              .text-xs.neutral700--text Invoice ID : {{ bill.rid }}
                v-btn.ml-1(icon x-small @click="copyText(bill.rid)")
                  v-icon(small color="neutral500") $yzi-copy-03
            
          .text-sm.font-semibold.neutral700--text.mt-2 Service & Medication
          div(v-for="(product, idx) in bill.products" :key="`pr-${idx}-${product.product.id}`")
            .text-xs.neutral700--text.mt-1 {{ idx + 1 }}. {{ product.product.name }}
              span.font-semibold.ml-1 {{ product.price | displayPrice($currency) }}
           
          v-row.mt-2(no-gutters align="center" v-for="transaction in bill.transactions" :key="transaction.uid")
            v-col.py-2
              .text-md.font-semibold.neutral700--text {{ transaction.payment_method }}
              .text-xs.neutral700--text(v-if="transaction.amount")
                span Total claim:
                span.font-semibold.ml-1 {{ transaction.amount | displayPrice($currency) }}
            v-col.py-2(cols="4")
              template(v-if="isNewPanelFlow(transaction)")
                y-button(:label="getClaimButtonLabel(transaction)" color="neutral700" size="sm" outlined :loading="loadingTransactionUid === transaction.uid" :disabled="transaction.claim_status === 'received'" @click="onOpenClaimDialog(transaction, bill)")
              template(v-else)
                y-select(v-model="transaction.claim_status" :items="statuses" item-text="text" item-value="value" placeholder="Claim status" :disabled="transaction.disabled" :class-name="transaction.disabled ? 'background-color: neutral300' : ''")
          v-divider.my-2
      div.text-md.danger500--text.text-center(v-else) No data

    v-card-actions.pb-4.pt-0.px-6
      y-button.mr-4(:label="$t('cancel')" underline color="neutral700" size="md" button-class="px-0" @click="closeDialog")
      v-spacer
      y-button(label="Save" text-color="neutral100" color="neutral700" size="md" dark :loading="isLoading" @click="saveData")

    create-single-claim-dialog(v-if="showCreateClaimDialog && selectedClaimTransaction" v-model="showCreateClaimDialog" :panel-name="selectedPanelName" :panel-id="selectedClaimTransaction.transaction.panel && selectedClaimTransaction.transaction.panel.id || selectedClaimTransaction.transaction.panel" :invoice-amount="selectedClaimTransaction.transaction.amount" :invoice-lead-pid="selectedClaimTransaction.bill.pid" :invoice-uid="selectedClaimTransaction.transaction.uid" :claim-status="selectedClaimTransaction.transaction.claim_status" :visit-date="selectedClaimTransaction.bill.record_date" :parent-claim="parentClaimData" @created="onClaimCreated" @updated="onClaimUpdated" @close="closeCreateClaimDialog")

    create-bulk-claim-dialog(v-if="showBulkClaimDialog" v-model="showBulkClaimDialog" :parent-claim="parentClaimData" @cancel="closeBulkClaimDialog" @updated="onBulkClaimUpdated")

    bulk-claim-confirmation-dialog(v-if="showBulkClaimConfirmation" v-model="showBulkClaimConfirmation" @confirmed="onConfirmBulkClaim" @canceled="onCancelBulkClaim")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import CreateSingleClaimDialog from '@/components/clinic/panel/dialogs/single/CreateSingleClaimDialog.vue'
import CreateBulkClaimDialog from '@/components/clinic/panel/dialogs/bulk/CreateBulkClaimDialog.vue'
import BulkClaimConfirmationDialog from '@/components/clinic/panel/dialogs/bulk/BulkClaimConfirmationDialog.vue'

export default {
  components: { CreateSingleClaimDialog, CreateBulkClaimDialog, BulkClaimConfirmationDialog },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    selectedBills: {
      type: Array,
      default: () => ([])
    }
  },
  data: () => ({
    isFetching: false,
    isLoading: false,
    loadingTransactionUid: null,
    bills: [],
    showCreateClaimDialog: false,
    showBulkClaimConfirmation: false,
    showBulkClaimDialog: false,
    selectedClaimTransaction: null,
    parentClaimData: null,
    selectedPanelName: '',
    statuses: [
      { value: 'new', text: 'New' },
      { value: 'submitted', text: 'Submitted' },
      { value: 'approved', text: 'Approved' },
      { value: 'received', text: 'Claim received' },
      { value: 'rejected', text: 'Rejected' }
    ],
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
      has_price: [(v) => !!v || 'This field is required', (v) => v >= 1|| `Amount should be more than ${this.$currency.symbol} 1`],
      not_empty_select: [v => !!v || 'This field is required']
    },
  }),
  computed: {
    ...mapGetters({ company: 'getCompany' }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
  },
  mounted () {
    this.setData()
  },
  methods: {
    ...mapActions(['showMessage']),
    setData () {
      let bills = JSON.parse(JSON.stringify(this.selectedBills))
      bills.forEach(bill => {
        bill.transactions = bill.transactions.map(m => { return { ...m, disabled: Boolean(m.claim_status === 'received') } })
      })
      this.bills = bills
    },
    async saveData () {
      try {
        this.isLoading = true
        let allUpdating = []
        this.bills.forEach(bill => {
          bill.transactions.forEach(txn => {
            if (!txn.disabled && txn.panel === null) {
              const endpoint = `/transactions/${txn.uid}`
              const payload = { claim_status: txn.claim_status }
              const update = this.$axios.patch(endpoint, payload).then(resp => {
                const activity = `Update claim ${txn.claim_status} (uid: ${txn.uid})`
                this.updateActivityLog(endpoint, payload, resp.data, 'PATCH', txn.uid, activity)
                this.$emit('updated', resp.data)
              })
              allUpdating.push(update)
            }
          })
        })
        await Promise.all([...allUpdating])
        this.$emit('reset')
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.isFetching = false
      }
    },
    updateActivityLog (endpoint, payload, response, method, id, activity) {
      let data = {
        company: this.company.id,
        object_id: id || null,
        object_ref: 'billing',
        activity: activity,
        raw_data: { endpoint, payload, response, method}
      }
      this.$axios.post('/users/logs', data)
        .catch(() => {})
    },
    isNewPanelFlow (transaction) {
      return transaction.panel != null
    },
    getClaimButtonLabel (transaction) {
      if (transaction.claim_status === 'received') return 'Claim received'
      return transaction.claim_status === 'new' ? 'Create claim' : 'Update claim'
    },
    async onOpenClaimDialog (transaction, bill) {
      this.loadingTransactionUid = transaction.uid
      this.selectedClaimTransaction = { transaction, bill }

      try {
        const { data } = await this.$axios.get(`/payment_methods/${transaction.ref_id}`)
        this.selectedPanelName = data.name || transaction.payment_method || ''
      } catch {
        this.loadingTransactionUid = null
        await this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        return
      }

      if (transaction.panel_claim != null && transaction.claim_status !== 'new') {
        try {
          const claimId = typeof transaction.panel_claim === 'object' ? transaction.panel_claim.id : transaction.panel_claim
          const { data } = await this.$axios.get(`/panels/${this.company.slug}/claims/${claimId}`)
          this.parentClaimData = data

          if (data.type === 'bulk') {
            this.loadingTransactionUid = null
            this.showBulkClaimConfirmation = true
            return
          }
        } catch (error) {
          console.error('Error fetching claim:', error)
          this.loadingTransactionUid = null
          await this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          return
        }
      } else {
        this.parentClaimData = null
      }

      this.loadingTransactionUid = null
      this.showCreateClaimDialog = true
    },
    onClaimCreated (data) {
      this.$emit('created', data)
      this.closeCreateClaimDialog()
    },
    onClaimUpdated () {
      this.$emit('reset')
      this.closeCreateClaimDialog()
    },
    closeCreateClaimDialog () {
      this.selectedClaimTransaction = null
      this.parentClaimData = null
      this.selectedPanelName = ''
      this.showCreateClaimDialog = false
    },
    onConfirmBulkClaim () {
      this.showBulkClaimConfirmation = false
      this.showBulkClaimDialog = true
    },
    onCancelBulkClaim () {
      this.showBulkClaimConfirmation = false
      this.parentClaimData = null
      this.selectedClaimTransaction = null
    },
    onBulkClaimUpdated () {
      this.$emit('reset')
      this.closeBulkClaimDialog()
    },
    closeBulkClaimDialog () {
      this.showBulkClaimDialog = false
      this.parentClaimData = null
      this.selectedClaimTransaction = null
    },
    closeDialog () {
      this.$emit('closed')
    },
    copyText(text) {
      navigator.clipboard.writeText(text).then(() => {
        this.showMessage(['success', 'Copied to clipboard'])
      }).catch(err => {
        console.error('Failed to copy text: ', err)
        this.showMessage(['error', 'Failed to copy text'])
      })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  } 
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
}
</style>